// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defaultPane .bottom-border {
	border: 0.2rem solid transparent;
	width: 100%;
}

.defaultPane .bottom-border-active {
	cursor: copy;
	border: 0.2rem solid;
	border-color: var(--color-bottom-border-highlight, rgb(100%, 65%, 0%));
}

.defaultPane {
	--default-pane-predicate-column: 16rem;
	--default-pane-object-indent: 1.75rem;
}

.defaultPane > tr {
	display: grid;
	grid-template-columns: minmax(0, var(--default-pane-predicate-column)) minmax(0, 1fr);
	align-items: flex-start;
}

.defaultPane > tr > td.pred {
	grid-column: 1;
	display: flex;
	align-items: flex-start;
	padding-left: 0 !important;
	box-sizing: border-box;
	min-width: 0;
}

.defaultPane > tr > td.pred > .labelTD {
	flex: 1 1 auto;
	min-width: 0;
	margin: 0;
	padding-top: 0;
	padding-bottom: 0;
}

.defaultPane > tr > td.pred > .iconTD {
	flex: 0 0 auto;
	width: auto;
	margin: 0;
}

.defaultPane > tr > td.obj {
	grid-column: 2;
	min-width: 0;
	box-sizing: border-box;
	align-self: start;
}

.defaultPane > tr > td[colspan='2'] {
	grid-column: 1 / -1;
}

.defaultPane[data-layout='mobile'] > tr {
	grid-template-columns: minmax(0, 1fr);
}

.defaultPane[data-layout='mobile'] > tr > td.pred,
.defaultPane[data-layout='mobile'] > tr > td.obj {
	display: block;
	grid-column: 1;
	width: 100%;
	box-sizing: border-box;
}

.defaultPane[data-layout='mobile'] > tr > td.pred {
	padding-bottom: var(--spacing-small, 0.1rem);
}

.defaultPane[data-layout='mobile'] > tr > td.obj {
	padding-left: var(--default-pane-object-indent) !important;
}

@media (max-width: 700px) {
	.defaultPane > tr {
		grid-template-columns: minmax(0, 1fr);
	}

	.defaultPane > tr > td.pred,
	.defaultPane > tr > td.obj {
		display: block;
		grid-column: 1;
		width: 100%;
		box-sizing: border-box;
	}

	.defaultPane > tr > td.pred {
		padding-bottom: var(--spacing-small, 0.1rem);
	}

	.defaultPane > tr > td.obj {
		padding-left: var(--default-pane-object-indent) !important;
	}
}
`, "",{"version":3,"sources":["webpack://./src/defaultPane.css"],"names":[],"mappings":"AAAA;CACC,gCAAgC;CAChC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,oBAAoB;CACpB,sEAAsE;AACvE;;AAEA;CACC,sCAAsC;CACtC,qCAAqC;AACtC;;AAEA;CACC,aAAa;CACb,qFAAqF;CACrF,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,0BAA0B;CAC1B,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,SAAS;CACT,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,SAAS;AACV;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;AACtC;;AAEA;;CAEC,cAAc;CACd,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,0DAA0D;AAC3D;;AAEA;CACC;EACC,qCAAqC;CACtC;;CAEA;;EAEC,cAAc;EACd,cAAc;EACd,WAAW;EACX,sBAAsB;CACvB;;CAEA;EACC,4CAA4C;CAC7C;;CAEA;EACC,0DAA0D;CAC3D;AACD","sourcesContent":[".defaultPane .bottom-border {\n\tborder: 0.2rem solid transparent;\n\twidth: 100%;\n}\n\n.defaultPane .bottom-border-active {\n\tcursor: copy;\n\tborder: 0.2rem solid;\n\tborder-color: var(--color-bottom-border-highlight, rgb(100%, 65%, 0%));\n}\n\n.defaultPane {\n\t--default-pane-predicate-column: 16rem;\n\t--default-pane-object-indent: 1.75rem;\n}\n\n.defaultPane > tr {\n\tdisplay: grid;\n\tgrid-template-columns: minmax(0, var(--default-pane-predicate-column)) minmax(0, 1fr);\n\talign-items: flex-start;\n}\n\n.defaultPane > tr > td.pred {\n\tgrid-column: 1;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tpadding-left: 0 !important;\n\tbox-sizing: border-box;\n\tmin-width: 0;\n}\n\n.defaultPane > tr > td.pred > .labelTD {\n\tflex: 1 1 auto;\n\tmin-width: 0;\n\tmargin: 0;\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n}\n\n.defaultPane > tr > td.pred > .iconTD {\n\tflex: 0 0 auto;\n\twidth: auto;\n\tmargin: 0;\n}\n\n.defaultPane > tr > td.obj {\n\tgrid-column: 2;\n\tmin-width: 0;\n\tbox-sizing: border-box;\n\talign-self: start;\n}\n\n.defaultPane > tr > td[colspan='2'] {\n\tgrid-column: 1 / -1;\n}\n\n.defaultPane[data-layout='mobile'] > tr {\n\tgrid-template-columns: minmax(0, 1fr);\n}\n\n.defaultPane[data-layout='mobile'] > tr > td.pred,\n.defaultPane[data-layout='mobile'] > tr > td.obj {\n\tdisplay: block;\n\tgrid-column: 1;\n\twidth: 100%;\n\tbox-sizing: border-box;\n}\n\n.defaultPane[data-layout='mobile'] > tr > td.pred {\n\tpadding-bottom: var(--spacing-small, 0.1rem);\n}\n\n.defaultPane[data-layout='mobile'] > tr > td.obj {\n\tpadding-left: var(--default-pane-object-indent) !important;\n}\n\n@media (max-width: 700px) {\n\t.defaultPane > tr {\n\t\tgrid-template-columns: minmax(0, 1fr);\n\t}\n\n\t.defaultPane > tr > td.pred,\n\t.defaultPane > tr > td.obj {\n\t\tdisplay: block;\n\t\tgrid-column: 1;\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t}\n\n\t.defaultPane > tr > td.pred {\n\t\tpadding-bottom: var(--spacing-small, 0.1rem);\n\t}\n\n\t.defaultPane > tr > td.obj {\n\t\tpadding-left: var(--default-pane-object-indent) !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
